import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";
import { QueryParams } from "@/models/query-params.model";
import { Denounce } from "@/models/denounce.model";

export class CommentRest {
  getAllComments(params?: QueryParams, topicId?: string): Observable<any> {
    const url: string = `/topic/${topicId}/comments`;
    return api.get(url, params);
  }
  likeComment(topicId: string, commentId: string): Observable<any> {
    const url: string = `/topic/${topicId}/comments/${commentId}/likes`;
    return api.post(url, {});
  }
  deleteComment(topicId: string, commentId: string): Observable<any> {
    const url: string = `/topic/${topicId}/comments/${commentId}`;
    return api.delete(url);
  }
  createComment(topicId: string, formData: FormData): Observable<any> {
    const url: string = `/topic/${topicId}/comments`;
    return api.post(url, formData);
  }
  getCommentById(topicId: string, commentId: string): Observable<any> {
    const url: string = `/topic/${topicId}/comments/${commentId} `;
    return api.get(url);
  }
  editComment(
    topicId: string,
    commentId: string,
    commentUpdated: FormData
  ): Observable<any> {
    const url: string = `/topic/${topicId}/comments/${commentId}`;
    return api.put(url, commentUpdated);
  }
  denounceComment(
    topicId: string,
    commentId: string,
    body: Denounce
  ): Observable<any> {
    const url: string = `/topic/${topicId}/comments/${commentId}/denounces`;
    return api.post(url, body);
  }
  getAllDenouncesComment(params: QueryParams): Observable<any> {
    const url: string = `/comment/denounces`;
    return api.get(url, params);
  }
  updateCommentDenounce(commentId: string, denounces: Array<Denounce>): Observable<any> {
    const url :string = `/comment/${commentId}/denounces`;
    return api.patch(url, denounces);
  }
}
